import {MoreHorizontalRegular} from "@fluentui/react-icons";
import {
    Card,
    CardHeader,
    CardFooter,
    Image,
    Text,
    Caption1,
    Button,
    Menu,
    MenuItem,
    MenuTrigger,
    MenuPopover,
    MenuList,
} from "@fluentui/react-components";
import * as React from "react";
import {OrganizationPostTypes} from "../constants/OrganizationPostTypes";
import Content from "../domain/Content";
import "./NewsfeedItem.css";
interface INewsfeedItemProps {
    content: Content;
    storyImage: string;
    onReadMore: (content: Content) => void;
    onDismiss: (content: Content) => void;
}
export default function NewsfeedItem (props: INewsfeedItemProps){
    function getAlertsDescription() {
        return (props.content.alerts && props.content.alerts.length > 0) ? props.content.alerts[0].description : "";
    }
    function handleOnDismiss  (e: any) {
        e.preventDefault();
        e.stopPropagation();
        if (props.onDismiss) {
            props.onDismiss(props.content);
        }
    }

    function handleMenuTrigger (e: any){
        e.stopPropagation();
    }

    function handleOnReadMore  (e: any){
        e.stopPropagation();
        e.preventDefault();
        if (props.onReadMore) {
            props.onReadMore(props.content);
        }
    }
    function render() {

        let storyInfo = (
            <div className="story-info">
                <div className="story-title">
                    <Text size={500} weight="semibold">{props.content.title}</Text>
                </div>
                <div className="story-summary">
                    <Text size={300} style={{color: "var(--colorNeutralForeground1)"}}>{props.content.summary}</Text>
                </div>
                <div className="smt-flex smt-flex__ai-center smt-flex__gap-1 story-source">
                    { props.content.authorName && props.content.authorName.length > 0 && ( <Text size={100} style={{color: "var(--colorNeutralForeground4)"}}>{props.content.authorName}</Text> ) }
                    <Caption1 style={{color: "var(--colorNeutralForeground4)"}}>{props.content.timeAgoSinceScheduled}</Caption1>
                </div>
            </div>
        );

        if (props.content.postTypeId === OrganizationPostTypes.Event) {
            let eventDateTimeString: string = `${props.content.eventStartWeekdayShortFormat}, ${props.content.eventStartDateShortFormat} - ${props.content.eventTimeStart} ${props.content.eventTimeZoneAbbreviation}`;
            if (props.content.isEventStarted && props.content.isMultiDayEvent) {
                eventDateTimeString = `Through ${props.content.eventEndWeekdayShortFormat}, ${props.content.eventEndDateShortFormat} ${props.content.eventTimeZoneAbbreviation}`;
            }
            storyInfo = (
                <div className="story-info">
                    <div className="story-title">
                        <Text size={500} weight="semibold">{props.content.title}</Text>
                    </div>
                    <div className="story-summary">
                        <Text size={300} weight="semibold" style={{color: "var(--colorPaletteRedForeground3)"}}>{eventDateTimeString}</Text>
                    </div>
                    <div className="story-source">
                        <Text size={100} style={{color: "var(--colorNeutralForeground4)"}}>{props.content.eventLocation}</Text>
                    </div>
                </div>
            );
        } else if (props.content.postTypeId === OrganizationPostTypes.Need) {

            storyInfo = (
                <div className="story-info">
                    <div className="story-title">
                        <Text size={500} weight="semibold">{props.content.title}</Text>
                    </div>
                    <div className="story-summary">
                        <Text size={300}  weight="semibold"  style={{color: "var(--colorPaletteRedForeground3)"}}>{"Needed: " + props.content.needQuantity.toLocaleString()}</Text>
                    </div>
                    <div className="story-source" >
                        <Text size={100} style={{color: "var(--colorNeutralForeground4)"}}>{"Needed by: " + props.content.needDate}</Text>
                    </div>
                </div>
            );
        }


        return (
            <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3 newsfeed-col">
                <Card className="newsfeed-item" onClick={handleOnReadMore}>
                    <CardHeader header={(
                        <div className="smt-flex smt-filled">
                            <Text size={300} weight="semibold" style={{color: "var(--colorBrandForeground1)"}}>{getAlertsDescription()}</Text>
                            {
                                !props.content.isDismissed && (
                                    <div className="smt-flex__push">
                                        <Menu>
                                            <MenuTrigger>
                                                <Button onClick={handleMenuTrigger} icon={<MoreHorizontalRegular/>}
                                                        appearance={"transparent"} title="More"/>
                                            </MenuTrigger>
                                            <MenuPopover>
                                                <MenuList>
                                                    <MenuItem onClick={handleOnDismiss}>Dismiss</MenuItem>
                                                </MenuList>
                                            </MenuPopover>
                                        </Menu>
                                    </div>
                                )
                            }
                        </div>
                    )}/>
                    <Image className="story-image" src={props.storyImage} fit="cover"/>
                    {storyInfo}

                    <CardFooter>
                        <Button onClick={handleOnReadMore}>{props.content.callOfActionForButton}</Button>
                    </CardFooter>

                </Card>
            </div>
        );
    }

    return render();
}
